const getFeaturedArticleQuery = /* GraphQL */ `
  query GetFeaturedArticle {
    featuredArticle {
      id
      title
      authors
      description
      url
      articleThumbnailUrl
    }
  }
`

export default getFeaturedArticleQuery
